import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=6a9834da&scoped=true&lang=pug"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"
import style0 from "./Button.vue?vue&type=style&index=0&id=6a9834da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9834da",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LsButtonSpinner: require('/workspace/portal/hosting/components/_base/Button/ButtonSpinner/ButtonSpinner.vue').default})
